import { render, staticRenderFns } from "./SuccessComp.vue?vue&type=template&id=7180d0a9&scoped=true&"
import script from "./SuccessComp.vue?vue&type=script&lang=js&"
export * from "./SuccessComp.vue?vue&type=script&lang=js&"
import style0 from "./SuccessComp.vue?vue&type=style&index=0&id=7180d0a9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7180d0a9",
  null
  
)

export default component.exports